import { useFlags } from 'config/useFlagsContext'

import { NewsInternalEstabilizacaoV50 } from '../internal-panels/NewsInternalEstabilizacaoV_50'
import { NewsInternalEstabilizacaoV51 } from '../internal-panels/NewsInternalEstabilizacaoV_51'
import { NewsInternalEstabilizacaoV52 } from '../internal-panels/NewsInternalEstabilizacaoV_52'
import { NewsInternalEstabilizacaoV53 } from '../internal-panels/NewsInternalEstabilizacaoV_53'
import { NewsInternalEstabilizacaoV54 } from '../internal-panels/NewsInternalEstabilizacaoV_54'
import { NewsInternalPanelCincoZero } from '../internal-panels/NewsInternalPanelV5_00'
import { NewsInternalPanelCincoUm } from '../internal-panels/NewsInternalPanelV5_10'
import { NewsInternalPanelCincoDois } from '../internal-panels/NewsInternalPanelV5_20'
import { NewsInternalPanelCincoTres } from '../internal-panels/NewsInternalPanelV5_30'
import { NewsInternalPanelCincoQuatro } from '../internal-panels/NewsInternalPanelV5_40'

export type NewsVersion =
  | '5-4-estabilizacao'
  | '5-4'
  | '5-3-estabilizacao'
  | '5-3'
  | '5-2-estabilizacao'
  | '5-2'
  | '5-1-estabilizacao'
  | '5-1'
  | '5-0-estabilizacao'
  | '5-0'

export type NewsTopics = ReadonlyArray<{ title: string; id: string }>

export type NewsItem = {
  title: string
  internalTitle?: string
  Panel: React.FC
  isEstabilizacao: boolean
  topics: NewsTopics
}

export default function useNewsItems() {
  const {
    CADASTRO_IMOVEL_ENABLED,
    SAUDE_INDIGENA_ENABLED,
    PILOTO_VINCULACAO_CUIDADO_ENABLED,
    SDC_PRE_ECLAMPSIA_ENABLED,
    PILOTO_INTEGRACAO_REGULACAO_ENABLED,
    PILOTO_DIABETES_HIPERTENSAO_LPC,
    PILOTO_PRESCRICAO_CONTROLADA,
    PROGRAMA_DIGNIDADE_MENSTRUAL,
  } = useFlags()

  const NEWS_ITEMS: Record<NewsVersion, NewsItem> = {
    '5-4-estabilizacao': {
      title: 'Estabilização 5.4',
      internalTitle: 'Versões de estabilização 5.4',
      Panel: NewsInternalEstabilizacaoV54,
      isEstabilizacao: true,
      topics: [
        {
          title: '5.4.33',
          id: 'estabilizacao-5-4-33',
        },
        {
          title: '5.4.32',
          id: 'estabilizacao-5-4-32',
        },
        {
          title: '5.4.31',
          id: 'estabilizacao-5-4-31',
        },
        {
          title: '5.4.30',
          id: 'estabilizacao-5-4-30',
        },
        {
          title: '5.4.29',
          id: 'estabilizacao-5-4-29',
        },
        {
          title: '5.4.28',
          id: 'estabilizacao-5-4-28',
        },
        {
          title: '5.4.27',
          id: 'estabilizacao-5-4-27',
        },
        {
          title: '5.4.26',
          id: 'estabilizacao-5-4-26',
        },
        {
          title: '5.4.25',
          id: 'estabilizacao-5-4-25',
        },
        {
          title: '5.4.24',
          id: 'estabilizacao-5-4-24',
        },
        {
          title: '5.4.23',
          id: 'estabilizacao-5-4-23',
        },
        {
          title: '5.4.22',
          id: 'estabilizacao-5-4-22',
        },
        {
          title: '5.4.21',
          id: 'estabilizacao-5-4-21',
        },
        {
          title: '5.4.19',
          id: 'estabilizacao-5-4-19',
        },
        {
          title: '5.4.18',
          id: 'estabilizacao-5-4-18',
        },
        {
          title: '5.4.17',
          id: 'estabilizacao-5-4-17',
        },
        {
          title: '5.4.15',
          id: 'estabilizacao-5-4-15',
        },
        {
          title: '5.4.14',
          id: 'estabilizacao-5-4-14',
        },
        {
          title: '5.4.13',
          id: 'estabilizacao-5-4-13',
        },
        {
          title: '5.4.11',
          id: 'estabilizacao-5-4-11',
        },
        {
          title: '5.4.10',
          id: 'estabilizacao-5-4-10',
        },
        {
          title: '5.4.9',
          id: 'estabilizacao-5-4-9',
        },
        {
          title: '5.4.8',
          id: 'estabilizacao-5-4-8',
        },
      ],
    },
    '5-4': {
      title: 'Versão 5.4',
      Panel: NewsInternalPanelCincoQuatro,
      isEstabilizacao: false,
      topics: [
        {
          title: 'Cálculo e exibição de Idade corrigida no card de Acompanhamento da criança',
          id: 'calculo-idade-corrigida-card-acompanhamento-crianca-5-4',
        },
        {
          title: 'Melhorias na gestão de Grupos de Exames',
          id: 'melhoria-grupos-exames-5-4',
        },
        ...(PILOTO_DIABETES_HIPERTENSAO_LPC
          ? [
              {
                title: 'Inclusão de condições na lista de problemas/condições com base no histórico clínico',
                id: 'inclusao-condicoes-historico-lpc-5-4',
              },
            ]
          : []),
        { title: 'Anexo de arquivos no prontuário', id: 'anexo-arquivos-5-4' },
        { title: 'Atualização da Ficha de notificação de caso suspeito', id: 'notificacao-ficha-sinan-5-4' },
        { title: 'Avaliação do M-CHAT-R na puericultura', id: 'mchat-5-4' },
        {
          title: 'Novas funcionalidades para o Acompanhamento de condições de saúde',
          id: 'acompanhamento-condicoes-saude-5-4',
        },
        { title: 'Novas funcionalidades para o Cuidado compartilhado', id: 'novas-funcionalidades-cuidado-5-4' },
        {
          title: 'Novo relatório para monitoramento de envios para RNDS',
          id: 'relatorio-envio-sucesso-rnds-5-4',
        },
        {
          title: 'Novo relatório gerencial de exames',
          id: 'relatorio-gerencial-exames-5-4',
        },
        {
          title: 'Novos gráficos para crianças, adolescentes e gestantes',
          id: 'graficos-criancas-adolescentes-gestantes-5-4',
        },
        {
          title: 'Novo módulo e melhorias no registro de Atividades coletivas',
          id: 'atividade-coletiva-5-4',
        },
        ...(PILOTO_INTEGRACAO_REGULACAO_ENABLED
          ? [{ title: 'Notificações no módulo de Regulação assistencial', id: 'notificacao-regulacao-5-4' }]
          : []),
        ...(PILOTO_INTEGRACAO_REGULACAO_ENABLED
          ? [{ title: 'Regulação assistencial', id: 'regulacao-assistencial-5-4' }]
          : []),
        {
          title: 'Indicação de óbito na Garantia de acesso',
          id: 'indicacao-obito-ga-5-4',
        },
        {
          title: 'Atualização dos resultados de exames quantitativos',
          id: 'atualizacao-resultados-exm-qualitativos-5-4',
        },
        {
          title: 'Atualização do atendimento de vacinação e do modelo RIA',
          id: 'atualizacao-atendimento-vacinacao-5-4',
        },
        {
          title: 'Atualização na exibição do IMC no atendimento de gestantes',
          id: 'atualizacao-imc-gestantes-5-4',
        },
        {
          title: 'Ajustes nos Gráficos de IMC e Peso durante a Gestação',
          id: 'ajustes-graficos-peso-imc-5-4',
        },
        {
          title: 'Sistema de Suporte à Decisão Clínica',
          id: 'suporte-decisao-clinica-5-4',
        },
        {
          title: 'Suporte à Decisão Clínica - Alerta de condutas recomendadas para dengue',
          id: 'suporte-decisao-clinica-conduta-dengue-5-4',
        },
        {
          title: 'Suporte à Decisão Clínica - Botão "Aplicar conduta recomendada" para dengue',
          id: 'suporte-decisao-clinica-botao-para-aplicar-conduta-recomendada-para-dengue-5-4',
        },
        ...(SDC_PRE_ECLAMPSIA_ENABLED
          ? [
              {
                title: 'Suporte à Decisão Clínica - Alerta de Risco de Pré-Eclâmpsia',
                id: 'sdc-alerta-risco-pre-eclampsia-5-4',
              },
            ]
          : []),
        ...(PILOTO_PRESCRICAO_CONTROLADA
          ? [
              {
                title: 'Prescrição digital de medicamentos controlados',
                id: 'prescricao-digital-controlada-5-4',
              },
            ]
          : []),
        ...(PROGRAMA_DIGNIDADE_MENSTRUAL
          ? [
              {
                title: 'Autorização para retirada de absorventes',
                id: 'programa-dignidade-menstrual-5-4',
              },
            ]
          : []),
      ],
    },
    '5-3-estabilizacao': {
      title: 'Estabilização 5.3',
      internalTitle: 'Versões de estabilização 5.3',
      Panel: NewsInternalEstabilizacaoV53,
      isEstabilizacao: true,
      topics: [
        {
          title: '5.3.33',
          id: 'estabilizacao-5-3-33',
        },
        {
          title: '5.3.32',
          id: 'estabilizacao-5-3-32',
        },
        {
          title: '5.3.31',
          id: 'estabilizacao-5-3-31',
        },
        {
          title: '5.3.30',
          id: 'estabilizacao-5-3-30',
        },
        {
          title: '5.3.29',
          id: 'estabilizacao-5-3-29',
        },
        {
          title: '5.3.28',
          id: 'estabilizacao-5-3-28',
        },
        {
          title: '5.3.27',
          id: 'estabilizacao-5-3-27',
        },
        {
          title: '5.3.26',
          id: 'estabilizacao-5-3-26',
        },
        {
          title: '5.3.25',
          id: 'estabilizacao-5-3-25',
        },
        {
          title: '5.3.24',
          id: 'estabilizacao-5-3-24',
        },
        {
          title: '5.3.23',
          id: 'estabilizacao-5-3-23',
        },
        {
          title: '5.3.22',
          id: 'estabilizacao-5-3-22',
        },
        {
          title: '5.3.21',
          id: 'estabilizacao-5-3-21',
        },
        {
          title: '5.3.20',
          id: 'estabilizacao-5-3-20',
        },
        {
          title: '5.3.19',
          id: 'estabilizacao-5-3-19',
        },
      ],
    },
    '5-3': {
      title: 'Versão 5.3',
      Panel: NewsInternalPanelCincoTres,
      isEstabilizacao: false,
      topics: [
        { title: 'Resultado estruturado da prova do laço', id: 'resultado-estruturado-prova-do-laco-5-3' },
        { title: 'Solicitação de exames/procedimentos', id: 'solicitacao-exames-procedimentos-5-3' },
        { title: 'Acompanhamento de condições de saúde', id: 'acompanhamento-de-condicoes-de-saude-5-3' },
        {
          title: 'Agendamento entre profissionais',
          id: 'agendamento-entre-profissionais-5-3',
        },
        {
          title: 'Atestado Digital',
          id: 'atestado-digital-5-3',
        },
        { title: 'Busca ativa de vacinação', id: 'busca-ativa-vacinacao-5-3' },
        ...(CADASTRO_IMOVEL_ENABLED
          ? [{ title: 'Cadastro de Imóveis e Famílias', id: 'cadastro-imoveis-familias-5-3' }]
          : []),
        {
          title: 'Cuidado Compartilhado',
          id: 'cuidado-compartilhado-5-3',
        },
        {
          title: 'Fixar profissionais na agenda',
          id: 'fixar-profissionais-agenda-5-3',
        },
        {
          title: 'Prescrição de medicamentos',
          id: 'prescricao-medicamentos-5-3',
        },
        {
          title: 'Unificação de base',
          id: 'unificacao-base-5-3',
        },
        {
          title: 'Videochamada do profissional convidado adaptada para telefone celular',
          id: 'videochamada-mobile-5-3',
        },
        {
          title: 'Videochamada do profissional convidado adaptada para tablet',
          id: 'videochamada-tablet-5-3',
        },
        ...(SAUDE_INDIGENA_ENABLED ? [{ title: 'Saúde indígena', id: 'saude-indigena-5-3' }] : []),
        {
          title: 'Importação do bolsa família',
          id: 'bolsa-familia-5-3',
        },
        {
          title: 'Nome social do profissional',
          id: 'nome-social-profissional-5-3',
        },
        ...[
          {
            title: 'Índice de Vulnerabilidade Clínico-Funcional',
            id: 'indice-de-vulnerabilidade-clinico-funcional-5-3',
          },
        ],
        {
          title: 'Índice de vulnerabilidade clínico funcional no Acompanhamento de condições de saúde',
          id: 'ivcf-no-acompanhamento-de-saude-5-3',
        },
        {
          title: 'API para transmissão de registros',
          id: 'api-transmissao-de-registros-5-3',
        },
        ...(PILOTO_VINCULACAO_CUIDADO_ENABLED
          ? [
              {
                title: 'Serviços de referência',
                id: 'servicos-de-referencia-5-3',
              },
            ]
          : []),
        {
          title: 'Histórico de acessos ao sistema',
          id: 'historico-acessos-5-3',
        },
        {
          title: 'Relatório de erros retornados pela RNDS',
          id: 'relatorio-erros-rnds-5-3',
        },
      ],
    },
    '5-2-estabilizacao': {
      title: 'Estabilização 5.2',
      internalTitle: 'Versões de estabilização 5.2',
      Panel: NewsInternalEstabilizacaoV52,
      isEstabilizacao: true,
      topics: [
        {
          title: '5.2.48',
          id: 'estabilizacao-5-2-48',
        },
        {
          title: '5.2.47',
          id: 'estabilizacao-5-2-47',
        },
        {
          title: '5.2.46',
          id: 'estabilizacao-5-2-46',
        },
        {
          title: '5.2.45',
          id: 'estabilizacao-5-2-45',
        },
        {
          title: '5.2.44',
          id: 'estabilizacao-5-2-44',
        },
        {
          title: '5.2.43',
          id: 'estabilizacao-5-2-43',
        },
        {
          title: '5.2.42',
          id: 'estabilizacao-5-2-42',
        },
        {
          title: '5.2.41',
          id: 'estabilizacao-5-2-41',
        },
        {
          title: '5.2.40',
          id: 'estabilizacao-5-2-40',
        },
        {
          title: '5.2.39',
          id: 'estabilizacao-5-2-39',
        },
        {
          title: '5.2.38',
          id: 'estabilizacao-5-2-38',
        },
        {
          title: '5.2.37',
          id: 'estabilizacao-5-2-37',
        },
        {
          title: '5.2.36',
          id: 'estabilizacao-5-2-36',
        },
        {
          title: '5.2.35',
          id: 'estabilizacao-5-2-35',
        },
        {
          title: '5.2.33',
          id: 'estabilizacao-5-2-33',
        },
        {
          title: '5.2.32',
          id: 'estabilizacao-5-2-32',
        },
        {
          title: '5.2.31',
          id: 'estabilizacao-5-2-31',
        },
        {
          title: '5.2.30',
          id: 'estabilizacao-5-2-30',
        },
        {
          title: '5.2.29',
          id: 'estabilizacao-5-2-29',
        },
        {
          title: '5.2.28',
          id: 'estabilizacao-5-2-28',
        },
        {
          title: '5.2.27',
          id: 'estabilizacao-5-2-27',
        },
        {
          title: '5.2.26',
          id: 'estabilizacao-5-2-26',
        },
        {
          title: '5.2.24',
          id: 'estabilizacao-5-2-24',
        },
        {
          title: '5.2.23',
          id: 'estabilizacao-5-2-23',
        },
        {
          title: '5.2.22',
          id: 'estabilizacao-5-2-22',
        },
        {
          title: '5.2.21',
          id: 'estabilizacao-5-2-21',
        },
        {
          title: '5.2.20',
          id: 'estabilizacao-5-2-20',
        },
      ],
    },
    '5-2': {
      title: 'Versão 5.2',
      Panel: NewsInternalPanelCincoDois,
      isEstabilizacao: false,
      topics: [
        { title: 'Atualização da competência do SIGTAP', id: 'atualizacao-competencia-sigtap-5-2' },
        {
          title: 'Acompanhamento do Território',
          id: 'acompanhamento-territorio-5-2',
        },
        { title: 'Busca ativa de vacinação', id: 'busca-ativa-vacinacao-5-2' },
        ...[
          {
            title: 'Cuidado Compartilhado',
            id: 'cuidado-compartilhado-5-2',
          },
        ],
        ...[
          {
            title: 'e-SUS APS Ampliado',
            id: 'esusAmpliado-5-2',
          },
        ],
        { title: 'Facilidades no agendamento de consultas de pré-natal', id: 'agendamento-pre-natal-5-2' },
        { title: 'Gerenciamento de cookies', id: 'gerenciamento-de-cookies-5-2' },
        { title: 'Garantia do acesso', id: 'garantia-acesso-5-2' },
        ...[
          {
            title: 'Histórico do Cuidado Compartilhado',
            id: 'historico-cuidado-compartilhado-5-2',
          },
        ],
        {
          title: 'Modelos personalizados para relatórios gerenciais',
          id: 'modelos-personalizados-relatorios-gerenciais-5-2',
        },
        { title: 'Prescrição de medicamentos', id: 'prescricao-medicamentos-5-2' },
        { title: 'Prescrição digital', id: 'prescricao-digital-5-2' },
        {
          title: 'Relatório gerencial de cuidado compartilhado',
          id: 'relatorio-gerencial-cuidado-compartilhado-5-2',
        },
        { title: 'RNDS - Envio de registros', id: 'envio-rnds-5-2' },
        { title: 'Unificação de cadastros', id: 'unificacao-de-cadastros-5-2' },
        { title: 'Videochamadas', id: 'videochamadas-5-2' },
        { title: 'Vínculo entre equipes do PEC', id: 'equipes-vinculadas-5-2' },
      ],
    },
    '5-1-estabilizacao': {
      title: 'Estabilização 5.1',
      internalTitle: 'Versões de estabilização 5.1',
      Panel: NewsInternalEstabilizacaoV51,
      isEstabilizacao: true,
      topics: [
        {
          title: '5.1.26',
          id: 'estabilizacao-5-1-26',
        },
        {
          title: '5.1.25',
          id: 'estabilizacao-5-1-25',
        },
        {
          title: '5.1.24',
          id: 'estabilizacao-5-1-24',
        },
        {
          title: '5.1.21',
          id: 'estabilizacao-5-1-21',
        },
        {
          title: '5.1.20',
          id: 'estabilizacao-5-1-20',
        },
        {
          title: '5.1.19',
          id: 'estabilizacao-5-1-19',
        },
        {
          title: '5.1.18',
          id: 'estabilizacao-5-1-18',
        },
        {
          title: '5.1.17',
          id: 'estabilizacao-5-1-17',
        },
      ],
    },
    '5-1': {
      title: 'Versão 5.1',
      Panel: NewsInternalPanelCincoUm,
      isEstabilizacao: false,
      topics: [
        { title: 'Marcadores de consumo alimentar', id: 'mca-5-1' },
        { title: 'Busca ativa de vacinação', id: 'busca-ativa-vacinacao-5-1' },
        {
          title: 'Encaminhamento externo',
          id: 'encaminhamento-5-1',
        },
        { title: 'Adaptação do PEC para uso do estagiário', id: 'estagiario-5-1' },
        { title: 'Reterritorialização', id: 'reterritorializacao-5-1' },
        { title: 'Observação do cidadão', id: 'observacao-5-1' },
        { title: 'Registro tardio', id: 'registro-tardio-5-1' },
        { title: 'Acompanhamento de cidadãos vinculados', id: 'acompanhamento-cidadaos-vinculados-5-1' },
        { title: 'CADSUS - Nova Sincronização', id: 'cadsus-sinc-5-1' },
      ],
    },
    '5-0-estabilizacao': {
      title: 'Estabilização 5.0',
      internalTitle: 'Versões de estabilização 5.0',
      Panel: NewsInternalEstabilizacaoV50,
      isEstabilizacao: true,
      topics: [
        {
          title: '5.0.24',
          id: 'estabilizacao-5-0-24',
        },
        {
          title: '5.0.23',
          id: 'estabilizacao-5-0-23',
        },
        {
          title: '5.0.22',
          id: 'estabilizacao-5-0-22',
        },
        {
          title: '5.0.21',
          id: 'estabilizacao-5-0-21',
        },
        {
          title: '5.0.20',
          id: 'estabilizacao-5-0-20',
        },
        {
          title: '5.0.19',
          id: 'estabilizacao-5-0-19',
        },
        {
          title: '5.0.18',
          id: 'estabilizacao-5-0-18',
        },
        {
          title: '5.0.17',
          id: 'estabilizacao-5-0-17',
        },
        {
          title: '5.0.16',
          id: 'estabilizacao-5-0-16',
        },
        {
          title: '5.0.15',
          id: 'estabilizacao-5-0-15',
        },
        {
          title: '5.0.14',
          id: 'estabilizacao-5-0-14',
        },
        {
          title: '5.0.13',
          id: 'estabilizacao-5-0-13',
        },
        {
          title: '5.0.12',
          id: 'estabilizacao-5-0-12',
        },
        {
          title: '5.0.11',
          id: 'estabilizacao-5-0-11',
        },
        {
          title: '5.0.10',
          id: 'estabilizacao-5-0-10',
        },
        {
          title: '5.0.9',
          id: 'estabilizacao-5-0-9',
        },
        {
          title: '5.0.8',
          id: 'estabilizacao-5-0-8',
        },
      ],
    },
    '5-0': {
      title: 'Versão 5.0',
      Panel: NewsInternalPanelCincoZero,
      isEstabilizacao: false,
      topics: [
        {
          title: 'Acompanhamentos',
          id: 'acompanhamentos-5-0',
        },
        {
          title: 'Alergias',
          id: 'alergias-5-0',
        },
        {
          title: 'Antecedentes',
          id: 'antecedentes-5-0',
        },
        {
          title: 'Atendimentos',
          id: 'atendimentos-5-0',
        },
        {
          title: 'Atendimento odontológico',
          id: 'atendimento-odonto-5-0',
        },
        {
          title: 'Atestados',
          id: 'atestados-5-0',
        },
        {
          title: 'Encaminhamentos e orientações',
          id: 'encaminhamento-orientacoes-5-0',
        },
        {
          title: 'Escuta inicial / pré-atendimento',
          id: 'escuta-inicial-5-0',
        },
        {
          title: 'Exames',
          id: 'exames-5-0',
        },
        {
          title: 'Histórico clínico do cidadão',
          id: 'historico-5-0',
        },
        {
          title: 'Medicamentos',
          id: 'medicamentos-5-0',
        },
        {
          title: 'Pré-natal / puerpério',
          id: 'pre-natal-5-0',
        },
        {
          title: 'Prontuário / folha de rosto',
          id: 'prontuario-5-0',
        },
        {
          title: 'Vacinação',
          id: 'vacinacao-5-0',
        },
      ],
    },
  }

  return NEWS_ITEMS
}
